<template>
  <div class="indexHomeWrap">
    <div class="indexHomeBanner">
      <img src="./home47.png" alt="" class="width100">
    </div>
    <div class="indexHome1">
      <div class="container">
        <div class="indexHomeTit text-center" aos="zoom-in">
          <p class="HomeTitP"><span class="indexHomeTit1"></span>三大版块 <span class="indexHomeTit2"></span></p>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 text-center">
            <dl class="hDl" aos="fade-down">
              <dt>自助服务端</dt>
              <dd>医生坐诊时间查询  </dd>
              <dd>预约挂号专家医生 ，取号分诊就医</dd>
              <dd>移动支付， 复诊评价， 电子病历调取  </dd>
              <dd>电子优惠卷领取 ，信息通知浏览 </dd>
              <dd>患者按病寻医就诊</dd>
              <dd>自助预约挂号机，排队叫号</dd>
            </dl>
          </div>
          <div class="col-xs-12 col-sm-3 col-md-3 ">
            <dl class="hDl text-center" aos="fade-down">
              <dt class="hDTit">系统管理端</dt>
              <dd>门诊管理， 医生管理 ，权限管理 </dd>
              <dd>设备管理 ，经济管理 ，数据管理 </dd>
              <dd>病历管理 ，会员管理</dd>
            </dl>
          </div>
          <div class="col-xs-12 col-sm-7 col-md-7">
              <div class="indexHomeImg">
                <img src="./home3.png" alt="" class="width100">
              </div>
          </div>
          <div class="col-xs-12 col-sm-2 col-md-2">
            <dl class="hDl text-center" aos="fade-down">
              <dt>线上移动端</dt>
              <dd>线上预约挂号</dd>
              <dd>医生坐诊时间查询</dd>
              <dd>在线咨询问诊</dd>
              <dd>预约医生变更提示</dd>
              <dd>优惠信息提示</dd>
              <dd>新闻消息提醒</dd>
              <dd>专家医生资源提示</dd>
              <dd>线上支付功能</dd>
              <dd>线上医患互动</dd>
              <dd>电子病历查看</dd>
            </dl>
            <a href="tel:18500058818" class="sysBtn minSysBtn">点击咨询</a>
          </div>
        </div>
      </div>
    </div>
    <div class="indexHome2">
      <div class="container">
        <div class="indexHomeTit text-center" aos="zoom-in">
          <p class="HomeTitP"><span class="indexHomeTit1"></span>系统优势 <span class="indexHomeTit2"></span></p>
        </div>
        <div class="row marginTop40">
          <div class="col-xs-12 col-sm-12 col-md-4">
            <div class="Home2Mes row"  aos="fade-down">
              <span class="text-center block col-xs-12 col-sm-12 col-md-12"> <img src="./home4.png" alt=""></span>
              <dl class="text-center col-xs-12 col-sm-6 col-md-12">
                <dt class="red">
                  优化就医流程
                </dt>
                <dd>
                  <p>按病寻医，自助挂号，便捷就诊，</p>
                  <p> 节约时间，病历查询，快速复诊，</p>
                  <p>评价反馈，贴心服务</p>
                </dd>
              </dl>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4">
              <div class="Home2Mes row"  aos="fade-down">
                <span class="text-center block col-xs-12 col-sm-12 col-md-12"> <img src="./home5.png" alt=""></span>
                <dl class="text-center col-xs-12 col-sm-12 col-md-12">
                  <dt class="red">
                    提升管理效率
                  </dt>
                  <dd>
                    <p>引流会员，信息收集，品牌宣传，</p>
                    <p>精准营销，提升服务，高效运营，</p>
                    <p>提成换算，便捷管理</p>
                  </dd>
                </dl>
              </div>

          </div>
          <div class="col-xs-12 col-sm-12 col-md-4">
            <div class="Home2Mes row"  aos="fade-down">
              <span class="text-center block col-xs-12 col-sm-12 col-md-12"> <img src="./home6.png" alt=""></span>
              <dl class="text-center col-xs-12 col-sm-12 col-md-12">
                <dt class="red">
                  数据指导经营
                </dt>
                <dd>
                  <p> 精准会员，病理病历，医生提成</p>
                  <p> 评价反馈，复诊比率，支付来源</p>
                  <p>  外方医生 ，库存管理</p>
                </dd>
              </dl>
            </div>
            <a href="tel:18500058818" class="sysBtn minSysBtn">点击咨询</a>
          </div>
        </div>
      </div>
    </div>
    <div class="indexHome3">
      <div class="container">
        <div class="indexHomeTit text-center"   aos="zoom-in">
          <p class="HomeTitP"><span class="indexHomeTit1"></span>主要功能 <span class="indexHomeTit2"></span></p>
        </div>
        <div class="row">
          <div class="col-xs-6 col-sm-4 col-md-3">
          <dl class="flex align-items">
            <dt>
              <img src="./home9.png" alt="">
            </dt>
            <dd>
              预约挂号
            </dd>
          </dl>
        </div>
          <div class="col-xs-6 col-sm-4 col-md-3">
          <dl class="flex align-items">
            <dt>
              <img src="./home10.png" alt="">
            </dt>
            <dd>
              预约取号
            </dd>
          </dl>
        </div>
          <div class="col-xs-6 col-sm-4 col-md-3">
          <dl class="flex align-items">
            <dt>
              <img src="./home11.png" alt="">
            </dt>
            <dd>
              分店管理
            </dd>
          </dl>
        </div>
          <div class="col-xs-6 col-sm-4 col-md-3">
          <dl class="flex align-items">
            <dt>
              <img src="./home12.png" alt="">
            </dt>
            <dd>
              数据统计
            </dd>
          </dl>
        </div>
          <div class="col-xs-6 col-sm-4 col-md-3">
          <dl class="flex align-items">
            <dt>
              <img src="./home13.png" alt="">
            </dt>
            <dd>
              优惠活动
            </dd>
          </dl>
        </div>
          <div class="col-xs-6 col-sm-4 col-md-3">
          <dl class="flex align-items">
            <dt>
              <img src="./home14.png" alt="">
            </dt>
            <dd>
              专家介绍
            </dd>
          </dl>
        </div>
          <div class="col-xs-6 col-sm-4 col-md-3">
          <dl class="flex align-items">
            <dt>
              <img src="./home15.png" alt="">
            </dt>
            <dd>
              店铺地图
            </dd>
          </dl>
        </div>
          <div class="col-xs-6 col-sm-4 col-md-3">
          <dl class="flex align-items">
            <dt>
              <img src="./home16.png" alt="">
            </dt>
            <dd>
              就医历史
            </dd>
          </dl>
        </div>
          <div class="col-xs-6 col-sm-4 col-md-3">
          <dl class="flex align-items">
            <dt>
              <img src="./home17.png" alt="">
            </dt>
            <dd>
              就医评价
            </dd>
          </dl>
        </div>
          <div class="col-xs-6 col-sm-4 col-md-3">
          <dl class="flex align-items">
            <dt>
              <img src="./home18.png" alt="">
            </dt>
            <dd>
              按病寻医
            </dd>
          </dl>
        </div>
          <div class="col-xs-6 col-sm-4 col-md-3">
          <dl class="flex align-items">
            <dt>
              <img src="./home19.png" alt="">
            </dt>
            <dd>
              在线支付
            </dd>
          </dl>
        </div>
          <div class="col-xs-6 col-sm-4 col-md-3">
          <dl class="flex align-items">
            <dt>
              <img src="./home20.png" alt="">
            </dt>
            <dd>
              会员管理
            </dd>
          </dl>
        </div>
          <div class="col-xs-6 col-sm-4 col-md-3">
            <dl class="flex align-items">
              <dt>
                <img src="./home21.png" alt="">
              </dt>
              <dd>
                电子开方
              </dd>
            </dl>
          </div>
          <div class="col-xs-6 col-sm-4 col-md-3">
            <dl class="flex align-items">
              <dt>
                <img src="./home22.png" alt="">
              </dt>
              <dd>
                分诊叫号
              </dd>
            </dl>
          </div>
          <div class="col-xs-6 col-sm-4 col-md-3">
            <dl class="flex align-items">
              <dt>
                <img src="./home23.png" alt="">
              </dt>
              <dd>
                抓药管理
              </dd>
            </dl>
          </div>
          <div class="col-xs-6 col-sm-4 col-md-3">
            <dl class="flex align-items">
              <dt>
                <img src="./home24.png" alt="">
              </dt>
              <dd>
                药房管理
              </dd>
            </dl>
          </div>
      </div>
      </div>
    </div>
    <div class="indexHome6">
      <div class="container">
        <div class="indexHomeTit text-center"   aos="zoom-in">
          <p class="HomeTitP"><span class="indexHomeTit1"></span>系统解决点 <span class="indexHomeTit2"></span></p>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12">
            <p class="text-center tit"><img src="./home36.png" alt="">方便患者</p>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 text-center marginTop40 minCenter">
            <!--<img src="./home37.png" alt="" class="minwidth100 home6Pres">-->
            <div class="home6Pres2" aos="flip-left">
              <p>查询医生信息，</p>
              <p>可根据患者自身的疾病，</p>
              <p>医生坐诊时间，门诊地理位置三方面</p>
              <p>快速的查找信息。</p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 text-center marginTop40 minCenter">
            <div class="home6Pres2" aos="flip-left">
              <p>快速挂号，</p>
              <p>预约医生，支付，分诊就医</p>
              <p>线上线下预约挂号形成闭环</p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 text-center marginTop40 minCenter">
            <div class="home6Pres2" aos="flip-left">
              <p>查询就医历史，</p>
              <p>对医生进行评价，便捷复诊</p>
              <p>快速就医。</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12">
            <p class="text-center tit titZ">
              <img src="./home40.png" alt="">方便管理者
            </p>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 text-center marginTop40">
            <div class=" home6Pres2" aos="flip-left">
              <p>迅速收集精准会员</p>
              <p>并进行管理</p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 text-center marginTop40">
            <div class=" home6Pres2" aos="flip-left">
              <p>进行医生的排班设置，</p>
              <p>医生信息的统一管理。</p>

            </div>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 text-center marginTop40">
            <div class=" home6Pres2" aos="flip-left">
              <p>对患者来源，信息来源，外方来源，</p>
              <p>合作来源进行统计分析</p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 text-center marginTop40">
            <div class=" home6Pres2" aos="flip-left">
              <p>对专长医生进行推荐，</p>
              <p>使患者根据自身的疾病能够更</p>
              <p>迅速的找到专家医生</p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 text-center marginTop40">
            <div class=" home6Pres2" aos="flip-left">
              <p>对患者，病理，经济，医生，评价，</p>
              <p>复诊率，权限，门诊，</p>
              <p>设备等进行数据统计分析管理</p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 text-center marginTop40">
            <div class="home6Pres2" aos="flip-left">
              <p>方便管理者进行优惠政策，</p>
              <p>推荐，预约诊疗等运营模式的</p>
              <p>发布执行</p>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="indexHome4">
      <div class="container">
        <div class="indexHomeTit text-center"  aos="zoom-in">
          <p class="HomeTitP" ><span class="indexHomeTit1"></span>他们都选择了我们 <span class="indexHomeTit2"></span></p>
        </div>
        <div class="row">
          <div class="col-xs-6 col-sm-4 col-md-4">
            <dl class="flex align-items"  aos="flip-left">
              <dt>
                <img src="./home27.png" alt="" class="width100">
              </dt>
            </dl>
          </div>
          <div class="col-xs-6 col-sm-4 col-md-4">
            <dl class="flex align-items"  aos="flip-left">
              <dt>
                <img src="./home28.png" alt="" class="width100">
              </dt>
            </dl>
          </div>
          <div class="col-xs-6 col-sm-4 col-md-4">
            <dl class="flex align-items"  aos="flip-left">
              <dt>
                <img src="./home29.png" alt="" class="width100">
              </dt>
            </dl>
          </div>
          <div class="col-xs-6 col-sm-4 col-md-4 ">
            <dl class="flex align-items"  aos="flip-left">
              <dt>
                <img src="./home30.png" alt="" class="width100">
              </dt>
            </dl>
          </div>
          <div class="col-xs-6 col-sm-4 col-md-4">
            <dl class="flex align-items"  aos="flip-left">
              <dt>
                <img src="./home31.png" alt="" class="width100">
              </dt>
            </dl>
          </div>
          <div class="col-xs-6 col-sm-4 col-md-4">
            <dl class="flex align-items"  aos="flip-left">
              <dt>
                <img src="./home32.png" alt="" class="width100">
              </dt>
            </dl>
          </div>

        </div>
      </div>
    </div>
    <div class="indexHome5">
      <div class="container">
        <div class="row flex align-items colorfff">
          <div class="col-xs-12 col-sm-4 col-md-4">
            <dl class="word">
              <dt>
                联系我们
              </dt>
              <dd>
                <img src="./aboutus3.png" alt="" class="wi80">
              </dd>
              <dd>
                全国服务热线：<a href="tel:400-168-1191" class="colorfff">400-168-1191</a>
              </dd>
              <dd>
                咨询热线：<a href="tel:18500058818 " class="colorfff">18500058818 </a><a href="tel:13611292757 " class="colorfff">13611292757 </a>
              </dd>
              <dd>
                邮箱：<a href="mailto:@yunbiaowulian.com" class="colorfff"> service@yunbiaowulian.com</a>
              </dd>
              <dd>
                地址： 北京市海淀区上地七街联创大厦407
              </dd>
            </dl>
          </div>
          <div class="col-xs-12 col-sm-8 col-md-8">
            <img src="./home34.png" alt="" class="width100">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import indexHomeTit from '../indexhometit/indexhometit.vue';
  import aos from '../../assets/jquery.min.js'
  import lightbox from '../../../static/js/aos.js'

  export default {
    components: {
      indexHomeTit,
      aos
    },
    data() {
      return {
        descList: [
          {'desc': '三大板块'},
          {'desc': '系统优势'},
          {'desc': '主要功能'},
          {'desc': '系统解决点'},
          {'desc': '他们都选择了我们'}
        ]
      }
    },
    mounted() {
      window.addEventListener("scroll",this.onScroll);
      AOS.init({
        offset: 200,
        duration: 600,
        easing: 'ease-in-sine',
      });
    },
    methods: {

    },
    destroyed: function()  {/*
      console.log(document.body.scrollTop)*/
      window.removeEventListener("scroll",this.onScroll);
    },
  };
</script>
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../../static/css/aos.css";
  .indexHomeWrap .indexHomeTit
    opacity:0
  .trans .indexHomeTit
    animation: firstTitle .2s forwards
    -moz-animation: firstTitle .2s forwards
    -webkit-animation: firstTitle .2s forwards
  .home1T .hDl dt
    animation: flipLateY .4s linear .5s 1 forwards
    -webkit-animation:flipLateY .4s linear .5s 1 forwards
    -moz-animation:flipLateY .4s linear .5s 1 forwards
  .home1T .hDl dD
    animation: flipLateY .3s linear .5s 1 forwards
    -webkit-animation:flipLateY .3s linear .5s 1 forwards
    -moz-animation:flipLateY .3s linear .5s 1 forwards
  .home6T .home6Pres
    animation home6Pres .2s linear .2s 1 forwards;
    -webkit-animation:home6Pres .2s linear .2s 1 forwards;
    -moz-animation:home6Pres .2s linear .2s 1 forwards;
  .home6T .jusCenter
    animation home6Pres .2s linear .2s 1 forwards;
    -webkit-animation:home6Pres .2s linear .2s 1 forwards;
    -moz-animation:home6Pres .2s linear .2s 1 forwards;
  .home2T .Home2Mes img
    -webkit-animation: flipInY .3s linear .5s 1 forwards;
    animation: flipInY .3s linear .5s 1 forwards
  .home2T .Home2Mes dt,.home2T .Home2Mes dd
    animation: flipInX .3s linear .5s 1 forwards
  @keyframes firstTitle
    0%
      opacity: 0;
      transform: scale(0)
    100%
      opacity: 1;
      transform: scale(1)
  @keyframes flipLateY
    0% {
      -webkit-transform: translateY(-50px);
      -moz-transform: translateY(-50px);
      opacity: 0
    }

    to {
      -webkit-transform: translateY(0px);
      -moz-transform: translateY(0px);
      opacity: 1
    }

  @keyframes flipInY
    0% {
      -webkit-transform: perspective(600px) rotateY(30deg);
      opacity: 0
    }

    to {
      -webkit-transform: perspective(600px) rotateY(0deg);
      opacity: 1
    }
  @keyframes flipInX
    0% {
      -webkit-transform: translateX(-20px);
      opacity: 0
    }

    to {
      -webkit-transform: translateX(0px);
      opacity: 1
    }
  @keyframes homeScale
    0% {
      -webkit-transform:scale(0.8);
    }

    50% {
      -webkit-transform: scale(1.1);
    }
    100% {
      -webkit-transform: scale(1);
    }
  @-webkit-keyframes home6Pres {
    0% {
      -webkit-transform: perspective(600px) rotateY(30deg);
      opacity: 0
    }

    to {
      -webkit-transform: perspective(600px) rotateY(0deg);
      opacity: 1
    }
  }
  .red
    color #860101
  .indexHome1
    width:100%
    padding-top 97px
    background: url(./home8.png) center no-repeat
    background-size: cover;
    .sysBtn
      display none
    .indexHomeImg
      padding: 10px 10px 0
      vertical-align bottom
      box-sizing: border-box
    .hDl
      line-height 1.5
      &:last-child
        margin-bottom 0
      dt
        font-size 24px
        color:#710d11
        line-height 2
        margin:0 0 20px;
        &.hDTit
          margin:90px 0 20px
      dd
        margin-bottom: 3px
        font-size 18px
        color:#787878
  .indexHome2
    width:100%
    padding-top 97px
    background: url(./home7.png) center no-repeat
    background-size: cover
    .sysBtn
      display none
    .Home2Mes
      dt
        padding:30px 0 38px
        font-size 24px
      dd
        font-size 18px
        line-height 1.5
  .indexHome3
    width:100%
    padding 97px 0 50px
    background: url(./home25.png) center no-repeat
    background-size: cover
    .indexHomeTit
      opacity 1
    .col-md-3
      margin-bottom 55px
      dl
        margin-bottom 0
        &:hover
          dt
            animation: homeScale .3s
      dd
        font-size 18px
        margin-bottom: 15px;
  .indexHome4
    width:100%
    padding-top 97px
    background: url(./home26.png) center no-repeat
    background-size: cover
    .indexHomeTit
      background-size 445px
      margin-bottom 90px
  .indexHome5
    width:100%
    padding 97px 0 20px
    background: url(./home33.png) center no-repeat
    background-size: cover
    .word
      dt
        font-size 36px
      dd
        font-size 18px
        line-height 1.5
        a:hover, a:focus
          color #fff
          text-decoration none
        .wi80
          display inline-block
          width:120px
          margin 15px 0
  .indexHome6
    width:100%
    padding 97px 0 50px
    background: url(./home35.png) center no-repeat
    background-size cover
    .home6Pres2
      height: 185px;
      width: 285px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color:#a4272c
      background: url(./home37.png) center no-repeat
    .home6Pres
      opacity 0
    .tit
        margin 0 0 10px;
        font-size 24px
        color #710d11
        white-space: nowrap;
        vertical-align middle
        img
          margin-right 40px
    .titZ
      margin-top 70px
  @media (min-width: 320px) and (max-width: 750px)
    .minwidth100
      width: 100%
    .indexHome1
      padding-top: 20px;
      .sysBtn
        width: 100%;
        display block
        padding: 7px 25px;
        font-size: 16px;
        background: #c50000
        border-radius 5px
        text-align: center;
        color:#fff
        margin 10px 0 20px
      .hDl
        margin-bottom 30px
        text-align: center;
        .hDTit
          margin:20px 0 20px;
      .indexHomeImg
        padding: 0px 20px 0;
    .indexHome4
      padding-top 20px
      .indexHomeTit
        background-size: 100%;
        margin-bottom: 30px;
    .indexHome2
      padding-top: 50px;
      .sysBtn
        width: 100%;
        display block
        padding: 7px 25px;
        font-size: 16px;
        background: #c50000
        border-radius 5px
        text-align: center;
        color:#fff
        margin 0 0 20px
      .Home2Mes
        /*display: flex;
        flex-direction: row;
        align-items: center;*/
        dt
          padding: 42px 0 5px;
        dd
          font-size 16px
          padding: 20px 0 20px;
    .indexHome5
      padding-top: 10px;
      .flex
        display block
        .word dt
          margin-bottom: 30px;
    .indexHome6
      padding-top: 10px;
      .tit
        margin 20px 0
      .minCenter
        float:none
        display block
        margin:0 auto 20px
    .indexHome3
      padding-top 30px
      dt img
        width:80%
      dd
        white-space nowrap


</style>



// WEBPACK FOOTER //
// src/components/home/home.vue